import groupBy from "lodash/groupBy"

import type EklaseStudent from "~/types/schema/eklase/Student"

interface NameItem {
  student: EklaseStudent
  suffix: number
}

function formatItem({ student, suffix }: NameItem): string {
  return suffix === 0 ? student.name : `${student.name} ${student.surname.slice(0, suffix)}.`
}

export function buildUniqueNameLabels(students: EklaseStudent[]): string[] {
  const items: NameItem[] = students.map((student) => ({ student, suffix: 0 }))

  let changed = true
  while (changed) {
    changed = false
    const groups = groupBy(items, formatItem)

    for (const group of Object.values(groups)) {
      if (group.length <= 1) { continue }
      for (const item of group) {
        if (item.suffix < item.student.surname.length) {
          item.suffix++
          changed = true
        }
      }
    }
  }

  return items.map(formatItem)
}

export function findFullName(students: EklaseStudent[], wheelLabel: string): string {
  const labels = buildUniqueNameLabels(students)
  const index = labels.indexOf(wheelLabel)
  if (index === -1) { return wheelLabel }
  const student = students[index]
  return `${student.name} ${student.surname}`
}
